Px.CanvasPageRenderer.CanvasContextPool = class CanvasContextPool {

  constructor() {
    this.contexts = {};
    this.contexts_created = 0;
    this.contexts_released = 0;
  }

  getContext(ctx_type, ctx_attributes={}) {
    const key = this.contextKey(ctx_type, ctx_attributes);

    if (!this.contexts[key]) {
      this.contexts[key] = [];
    }

    let ctx = this.contexts[key].pop();
    if (ctx) {
      return ctx;
    }

    const canvas = new OffscreenCanvas(1, 1);
    ctx = canvas.getContext(ctx_type, ctx_attributes);
    ctx.__px_context_key = key;

    this.contexts_created++;

    return ctx;
  }

  releaseContext(ctx) {
    const key = ctx.__px_context_key;
    if (!key) {
      throw new Error('Expected context to have a `__px_context_key`; context not created by this pool?');
    }
    if (!this.contexts[key]) {
      throw new Error(`Expected internal storage to be present for context key ${key}; context not created by this pool?`);
    }

    ctx.canvas.width = 1;
    ctx.canvas.height = 1;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, 1, 1);
    if (ctx.reset) {  // browser support is not quite there yet; Safari :'(
      ctx.reset();
    }

    this.contexts[key].push(ctx);

    this.contexts_released++;
  }

  // -------
  // Private
  // -------

  contextKey(ctx_type, ctx_attributes) {
    let key = ctx_type;
    Object.keys(ctx_attributes).sort().forEach(attr => {
      key += `_${attr}:#{ctx_attributes[attr]}`;
    });
    return key;
  }

};

Px.CanvasPageRenderer.canvas_context_pool = new Px.CanvasPageRenderer.CanvasContextPool();
